export default __webpack_public_path__ + "static/media/src_img_5.65a0f5e2.jpg";